export default __webpack_public_path__ + "static/media/icon-gaming.388a95ab.svg";